import { GenericResultModel } from "./base";

export interface ConfigTrafficLightResultModel extends GenericResultModel {
  configTrafficLightItem: ConfigTrafficLightItem;
}

export interface ConfigTrafficLightRequestModel {
  configTrafficLightItem: ConfigTrafficLightItem;
}

export interface ConfigTrafficLightItem {
  id?: number;
  greenLimitDays?: number;
  yellowLimitDays?: number;
  redLimitDays?: number;
  reminderVisible?: boolean;
  greenBefore: boolean;
  yellowBefore: boolean;
  redBefore: boolean;
}

export interface TrafficLightTimelineConfig {
  id: number;
  color: string;
  days: number;
  before: boolean;
  text: string;
}

export enum Direction {
  Before = "before",
  After = "after",
}

export enum Color {
  Green = "#8AB446",
  Yellow = "#F9D44C",
  Red = "#D24A43",
}
